import { render, staticRenderFns } from "./priceListAdminAction.vue?vue&type=template&id=a3fbec5c&scoped=true"
import script from "./priceListAdminAction.vue?vue&type=script&lang=js"
export * from "./priceListAdminAction.vue?vue&type=script&lang=js"
import style0 from "./priceListAdminAction.vue?vue&type=style&index=0&id=a3fbec5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3fbec5c",
  null
  
)

export default component.exports